"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_rdf_metadata_1 = require("@comunica/bus-rdf-metadata");

var stream_1 = require("stream");
/**
 * An RDF Metadata Actor that splits off the metadata based on the existence of a 'foaf:primaryTopic' link.
 * Only non-triple quad streams are supported.
 */


var ActorRdfMetadataPrimaryTopic =
/*#__PURE__*/
function (_bus_rdf_metadata_1$A) {
  _inherits(ActorRdfMetadataPrimaryTopic, _bus_rdf_metadata_1$A);

  function ActorRdfMetadataPrimaryTopic(args) {
    _classCallCheck(this, ActorRdfMetadataPrimaryTopic);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfMetadataPrimaryTopic).call(this, args));
  }

  _createClass(ActorRdfMetadataPrimaryTopic, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!action.triples) {
                  _context.next = 2;
                  break;
                }

                throw new Error('This actor only supports non-triple quad streams.');

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var _this = this;

        var data, metadata, attachListeners;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = new stream_1.Readable({
                  objectMode: true
                });
                metadata = new stream_1.Readable({
                  objectMode: true
                }); // Delay attachment of listeners until the data or metadata stream is being read.

                attachListeners = function attachListeners() {
                  // Attach listeners only once
                  data._read = metadata._read = function () {
                    return;
                  }; // Forward errors


                  action.quads.on('error', function (error) {
                    data.emit('error', error);
                    metadata.emit('error', error);
                  }); // First pass over data to categorize in graphs,
                  // and to detect the primaryTopic triple.

                  var graphs = {};
                  var endpointIdentifier = null;
                  var primaryTopics = {};
                  action.quads.on('data', function (quad) {
                    if (quad.predicate.value === 'http://rdfs.org/ns/void#subset' && quad.object.value === action.url) {
                      endpointIdentifier = quad.subject.value;
                    } else if (quad.predicate.value === 'http://xmlns.com/foaf/0.1/primaryTopic') {
                      primaryTopics[quad.object.value] = quad.subject.value;
                    }

                    var quads = graphs[quad.graph.value];

                    if (!quads) {
                      quads = graphs[quad.graph.value] = [];
                    }

                    quads.push(quad);
                  }); // When the stream has finished,
                  // determine the appropriate metadata graph,
                  // and emit all quads to the appropriate streams.

                  action.quads.on('end', function () {
                    var metadataGraph = endpointIdentifier ? primaryTopics[endpointIdentifier] : null;

                    for (var graphName in graphs) {
                      if (graphName === metadataGraph) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                          for (var _iterator = graphs[graphName][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var _quad = _step.value;
                            metadata.push(_quad);
                          } // Also emit metadata to data if requested

                        } catch (err) {
                          _didIteratorError = true;
                          _iteratorError = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                              _iterator.return();
                            }
                          } finally {
                            if (_didIteratorError) {
                              throw _iteratorError;
                            }
                          }
                        }

                        if (_this.metadataToData) {
                          var _iteratorNormalCompletion2 = true;
                          var _didIteratorError2 = false;
                          var _iteratorError2 = undefined;

                          try {
                            for (var _iterator2 = graphs[graphName][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                              var quad = _step2.value;
                              data.push(quad);
                            }
                          } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                          } finally {
                            try {
                              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                              }
                            } finally {
                              if (_didIteratorError2) {
                                throw _iteratorError2;
                              }
                            }
                          }
                        }
                      } else {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                          for (var _iterator3 = graphs[graphName][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var _quad3 = _step3.value;
                            data.push(_quad3);
                          }
                        } catch (err) {
                          _didIteratorError3 = true;
                          _iteratorError3 = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                              _iterator3.return();
                            }
                          } finally {
                            if (_didIteratorError3) {
                              throw _iteratorError3;
                            }
                          }
                        }

                        if (!metadataGraph && _this.dataToMetadataOnInvalidMetadataGraph) {
                          var _iteratorNormalCompletion4 = true;
                          var _didIteratorError4 = false;
                          var _iteratorError4 = undefined;

                          try {
                            for (var _iterator4 = graphs[graphName][Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                              var _quad2 = _step4.value;
                              metadata.push(_quad2);
                            }
                          } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                          } finally {
                            try {
                              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                _iterator4.return();
                              }
                            } finally {
                              if (_didIteratorError4) {
                                throw _iteratorError4;
                              }
                            }
                          }
                        }
                      }
                    }

                    data.push(null);
                    metadata.push(null);
                  });
                };

                data._read = metadata._read = function () {
                  attachListeners();
                };

                return _context2.abrupt("return", {
                  data: data,
                  metadata: metadata
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);

  return ActorRdfMetadataPrimaryTopic;
}(bus_rdf_metadata_1.ActorRdfMetadata);

exports.ActorRdfMetadataPrimaryTopic = ActorRdfMetadataPrimaryTopic;